__turbopack_context__.v({
  "freeBox": "PlasmicMoneyToAccountTime-module__pWTj_G__freeBox",
  "img__nQiX2": "PlasmicMoneyToAccountTime-module__pWTj_G__img__nQiX2",
  "img__yeCaS": "PlasmicMoneyToAccountTime-module__pWTj_G__img__yeCaS",
  "imgglobal_themeOrange_override__yeCaSdYuRs": "PlasmicMoneyToAccountTime-module__pWTj_G__imgglobal_themeOrange_override__yeCaSdYuRs",
  "lgTimeFromNow": "PlasmicMoneyToAccountTime-module__pWTj_G__lgTimeFromNow",
  "lgTimeFromNowglobal_themePurpleDark_override": "PlasmicMoneyToAccountTime-module__pWTj_G__lgTimeFromNowglobal_themePurpleDark_override",
  "root": "PlasmicMoneyToAccountTime-module__pWTj_G__root",
  "text": "PlasmicMoneyToAccountTime-module__pWTj_G__text",
  "textglobal_themeOrange_override": "PlasmicMoneyToAccountTime-module__pWTj_G__textglobal_themeOrange_override",
  "textglobal_themePurpleDark_override": "PlasmicMoneyToAccountTime-module__pWTj_G__textglobal_themePurpleDark_override",
});
